import { Sparkles } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

type Props = {
    inline?: boolean;
};

export function AiCapturedBadge({ inline = false }: Props) {
    return (
        <Tooltip>
            <TooltipTrigger
                aria-label="Captured by AI"
                render={
                    <span
                        role="img"
                        className={cn(
                            "ai-captured-badge inline-flex items-center p-1 text-blue-500",
                            inline
                                ? "relative h-auto w-auto shrink-0"
                                : "absolute top-1/2 right-1 -translate-y-1/2",
                        )}
                    />
                }
            >
                <Sparkles className="size-3" aria-hidden />
            </TooltipTrigger>
            <TooltipContent side="top" align="center" sideOffset={8}>
                Captured by AI
            </TooltipContent>
        </Tooltip>
    );
}
